<div class="vv-list">
    <ng-content></ng-content>
</div>
